import { BuildPath } from  '@/helpers/Paths';
import { fieldType, orderTable, sortByTable } from  '@/interfaces/plannerSettings';
import React from 'react';

const TableHeading = ({order, setOrder, field, label}: {order, setOrder:(order:sortByTable) => void, field:string, label:string}) => {

    return (
        
        <th className='order' onClick={() => setOrder({field:field, order:order?.order === orderTable.asc ? orderTable.dsc : orderTable.asc, fieldType: fieldType.number})}>
            
            <span>{label}</span>

            {order.field === field && 
                <img className={`order-icon ${order.order}`} src={`${BuildPath()}/images/planner/chevron-down.svg`} alt="Order" />
            }
        </th>

    );
};

export default TableHeading;